import { Divider, Typography } from '@mui/material'
import SimulationDatesPickerField from './components/DatesPicker/SimulationDatesPickerField'
import { Name } from './components/Name'
import { Notes } from './components/Notes'
import { FormProps as Props } from './typings'
import { emptySimulationId } from './utils'
import * as Texts from './../../intl'

const FormContent: React.FC<Props> = ({
  initialValues: { id },
  firstDayNotArchived,
  today,
  maxIntervalLength,
  simulationsNames,
}) => {
  const showCalendar: boolean = id === emptySimulationId

  return (
    <>
      {showCalendar && (
        <>
          <SimulationDatesPickerField
            name="simulationDate"
            label={''}
            wrappedInputProps={{
              firstDayNotArchived: firstDayNotArchived || new Date(),
              today,
              maxIntervalLength,
            }}
          />
          <Typography variant="body2" color="text.secondary">
            {Texts.getSimulationDatePickerDescription()}
          </Typography>

          <Divider />
        </>
      )}

      <Name simulationNames={simulationsNames} />

      <Notes />
    </>
  )
}

export default FormContent
